export default __webpack_public_path__ + "static/media/main_logo.20f05153.png";